// @flow
import React from "react";
import PropTypes from "prop-types";
import SVG from "react-inlinesvg";
import noon from "../../../images/common/noon.svg";
import styles from "./Loader.scss";

const Loader = (props: Object) => {
  const { style } = props;
  return (
    <div
      style={{
        ...{
          display: "flex",
          alignItems: "center",
          width: "100%",
          justifyContent: "center",
          height: "100vh"
        },
        ...style
      }}
    >
      <div className={styles.wrapper}>
        <svg
          version="1.1"
          xmlns="http://www.w3.org/2000/svg"
          width="70"
          height="66"
          viewBox=" 0 0 70 66"
        >
          <path
            className={styles.path}
            d="M -1 33.919 C -1 51.28 13.756 64.767 30.916 64.767 C 48.878 64.767 63.433 50.278 63.433 32.584 C 63.433 22.234 58.425 13.154 51.014 7.077 L 45.606 16.425 C 50.079 20.231 53.15 26.107 53.15 32.717 C 53.15 44.736 43.202 54.618 30.916 54.618 C 18.697 54.618 8.748 44.736 8.748 32.383 C 8.748 30.914 8.882 29.445 9.149 28.044 L -1 33.919 Z M 40.931 1.602 C 37.86 0.467 35.123 0 32.385 0 C 30.315 0 28.512 0.267 27.177 0.534 L 20.233 12.553 C 22.77 11.084 26.042 10.282 29.581 10.282 C 31.651 10.282 33.52 10.549 35.457 11.084 L 40.931 1.602 Z"
          />
        </svg>
      </div>
    </div>
  );
};

Loader.propTypes = {};

Loader.getDefaultProps = {};

export default Loader;



// WEBPACK FOOTER //
// ./src/components/common/loader/Loader.js